// Onde a negociação está na Validação de Dados, numa regra só para todas as telas
// (#6541, pedido do Felipe, 03/11/2026).
//
// - Na fila (status `termo_assinado`): espera a analista. É o "Em validação de dados"
//   do Analytics, da Visão Geral e do CRM, e a aba "Pendentes de Análise" da tela de
//   Validação de Dados. Inclui a reanálise: a negociação que voltou para a fila.
// - Com pendência (status `termo_analise`): a analista já decidiu uma vez e pediu algo
//   ao cliente ou ao vendedor (documento, garantia ou confirmação). Aparece à parte,
//   para acompanhar, e NÃO soma no "Em validação de dados".
//
// SLA da analista (24 h úteis, tabela `configuracoes_sla`): vale só para a primeira
// análise. Depois da primeira decisão o relógio não volta: a espera na pendência e a
// reanálise não contam contra ela. O sinal é
// `negociacoes.analise_cadastral_minutos_realizados`, que o assistente da validação grava
// na primeira conclusão e não muda mais.
//
// Função pura, sem I/O: roda sob `node --test` com type-stripping.

export const STATUS_NA_FILA = 'termo_assinado';
export const STATUS_COM_PENDENCIA = 'termo_analise';

export type SituacaoNaValidacao = 'fila' | 'pendencia';

/** Onde a negociação está hoje na Validação de Dados; `null` = fora dela. */
export function situacaoNaValidacao(status: string | null | undefined): SituacaoNaValidacao | null {
  if (status === STATUS_NA_FILA) return 'fila';
  if (status === STATUS_COM_PENDENCIA) return 'pendencia';
  return null;
}

export const naFilaDaValidacao = (status: string | null | undefined): boolean => status === STATUS_NA_FILA;
export const comPendenciaNaValidacao = (status: string | null | undefined): boolean => status === STATUS_COM_PENDENCIA;

/** A analista já decidiu esta negociação pelo menos uma vez (o tempo da 1ª análise está gravado). */
export const jaTeveAPrimeiraAnalise = (minutosRealizados: number | null | undefined): boolean => minutosRealizados != null;

/**
 * O SLA da analista está contando agora? Só com a negociação na fila e na primeira
 * análise. Reanálise (voltou para a fila depois de uma decisão) não conta.
 */
export const slaDaAnalistaConta = (status: string | null | undefined, minutosRealizados: number | null | undefined): boolean =>
  naFilaDaValidacao(status) && !jaTeveAPrimeiraAnalise(minutosRealizados);
